/**
 * TanStack Query hooks for `campaign-wise-invoice-grouping`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	campaignWiseInvoiceGroupingQueryKeys,
	type CreateCampaignWiseInvoiceGroupingBody,
	type ListCampaignWiseInvoiceGroupingResponse,
	type CampaignWiseInvoiceGroupingRow,
} from "./api";

export function useCampaignWiseInvoiceGroupingList(): UseQueryResult<ListCampaignWiseInvoiceGroupingResponse, Error> {
	return useQuery({
		queryKey: campaignWiseInvoiceGroupingQueryKeys.list(),
		queryFn: list,
	});
}

export function useCampaignWiseInvoiceGroupingCreate(): UseMutationResult<CampaignWiseInvoiceGroupingRow, Error, CreateCampaignWiseInvoiceGroupingBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignWiseInvoiceGroupingQueryKeys.all });
		},
	});
}

export function useCampaignWiseInvoiceGroupingDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignWiseInvoiceGroupingQueryKeys.all });
		},
	});
}
